import React from "react";
import { CFooter, Text2, View } from "../components";

import styled from "styled-components";

import bye from "../icons/bye.svg";
import logo from "../icons/curon_logo.svg";

// 404
const LargeText = styled(Text2)`
  font-family: Hiragino Kaku Gothic ProN;
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
`;

// Message (Page not found)
const M = styled.a`
  font-family: Hiragino Sans;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #2ba168;
  text-decoration: underline;
  margin-bottom: 45px;
`;

const LogoBox = styled.div`
  background: white;
  margin: auto;
`;

const Box = styled(View)`
  background: white;
  width: 92%;
  padding-top: 40px;
`;

const Spacer = styled.div`
  background: white;
  height: 21px;
`;

const TextBox = styled.div`
  background: white;
  width: 85%;
  margin: 32px auto;
`;

const NotFound = (props: any) => {
  return (
    <Box>
      <LogoBox>
        <img src={logo} alt="logo" />
      </LogoBox>
      <TextBox>
        <LargeText>
          当サイト「curon
          TypeC」は2023年9月30日をもちましてサービス提供を終了しました。ご利用ありがとうございました。
        </LargeText>
        <Spacer />
        <LargeText>
          今後は、オンライン診療サービスcuron（クロン）をご活用ください。以下のリンクからご利用いただけます。
        </LargeText>
      </TextBox>
      <M href="https://app.curon.co">オンライン診療サービスcuron（クロン）</M>
      <LogoBox>
        <img src={bye} alt="bye" />
      </LogoBox>
      <CFooter />️
    </Box>
  );
};

export default NotFound;
